import { render, staticRenderFns } from "./InvoicesPage.vue?vue&type=template&id=3b7a82d0&"
import script from "./InvoicesPage.vue?vue&type=script&lang=js&"
export * from "./InvoicesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports